import type { FaireProductEntity } from "../../entity_types/product";

export const p_quye73cp68: FaireProductEntity = {
  token: "p_quye73cp68",
  type: "product",
  name: "Sweetgrass Coaster Set + Holder",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/06b5a8573bba56d23d02c71ab07b1c17757532011fa945de57fa6a1d8874f430.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5f5732fd6ff71026971d08806dcb7e7d4142e6d03a37481252565b210cfcb0ec.jpeg",
    "https://cdn.faire.com/fastly/2fbd6b615c2c13776db633749da428573a91fec3a49d3ceb90a6a1d6a8307c99.jpeg",
    "https://cdn.faire.com/fastly/bdd8ed928407bd565e99062d71275581c6e3588a2c5c3cd4d920498632f42bc1.jpeg"
  ],
  priceDollars: 16,
  description: "• Diameter: ~4\" coaster\n\nAdd a fun touch to your barware or coffee table with this set of 4 woven coasters plus holder. They are special for entertaining and practical for everyday use! Each coaster is handmade in Rwanda, where female weavers hand-weave sweetgrass, a fragrant grass with a subtle sweetness.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:18.767Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
